// Web guides and training (EXP 05). Guide images are small SVGs shown through
// an img tag, so nothing in them can run as script.

import { esc } from '../api';
import type content from '../content/sample-content.json';

type Content = typeof content;

export interface GuideStep {
  text: string;
  media?: { alt: string; svg?: string };
}

export interface Guide {
  id: string;
  title: string;
  system: string;
  summary: string;
  placeholder?: boolean;
  steps: GuideStep[];
}

export function svgImage(svg: string, alt: string): string {
  if (!svg.startsWith('<svg')) return '';
  return `<img class="step-media" alt="${esc(alt)}" src="data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}" />`;
}

export function renderGuideList(guides: Guide[], training: Content['training']): string {
  return `
<h1>Guides</h1>
<ul class="guides">${guides
    .map(
      (g) =>
        `<li class="card"><h2><a href="#/guides/${esc(g.id)}">${esc(g.title)}</a></h2><p>${esc(g.summary)}</p><p class="muted">${esc(
          g.system,
        )}${g.placeholder ? ' · <span class="placeholder">placeholder</span>' : ''}</p></li>`,
    )
    .join('')}</ul>
<h2 id="training">Training</h2>
<ul>${training
    .map((t) => `<li>${esc(t.title)} <span class="muted">${esc(t.system)}</span>${t.placeholder ? ' <span class="placeholder">placeholder</span>' : ''}</li>`)
    .join('')}</ul>`;
}

export function renderGuide(guide: Guide): string {
  if (guide.placeholder || guide.steps.length === 0) {
    return `<h1>${esc(guide.title)}</h1><p class="placeholder">${esc(guide.summary)}</p><p><a href="#/guides">All guides</a></p>`;
  }
  return `
<article class="guide">
  <h1>${esc(guide.title)}</h1>
  <p class="muted">${esc(guide.system)}</p>
  <p>${esc(guide.summary)}</p>
  <ol class="steps">${guide.steps
    .map((s) => `<li><p>${esc(s.text)}</p>${s.media?.svg ? svgImage(s.media.svg, s.media.alt) : ''}</li>`)
    .join('')}</ol>
  <p><a href="#/guides">All guides</a></p>
</article>`;
}
